import { render, staticRenderFns } from "./list-vacancy.vue?vue&type=template&id=d1a874da&scoped=true"
import script from "./list-vacancy.vue?vue&type=script&lang=js"
export * from "./list-vacancy.vue?vue&type=script&lang=js"
import style0 from "./list-vacancy.vue?vue&type=style&index=0&id=d1a874da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a874da",
  null
  
)

export default component.exports